<template>
	<router-view />
</template>

<script>
	import {
		defineComponent
	} from "vue";
	export default defineComponent({
		name: "mainPage",
		components: {},
	});
</script>

<style lang="less">
	@font-face {
		font-family: 'SourceHanSansCN-Regular';
		src: url('./font/SourceHanSansCN-Regular.ttf');
		//src: url('./font/SourceHanSansCN-Regular.woff');
		//src: url('./font/SourceHanSansCN-Regular.otf');
		font-weight: 100;
	}

	body {
		font-family: 'SourceHanSansCN-Regular';
		font-size: 100%;
		margin: 0;
		padding: 0;
	}
</style>